import { collectionEngineV1 } from '../apis.js';
const reqCases = collectionEngineV1('/transaction-accounts');
export const create = (newTransactionAccount) => reqCases('POST', `/`, {
    body: newTransactionAccount,
});
export const getAll = () => reqCases('GET', `/`);
export const patch = (transactionAccountId, patch) => reqCases('PATCH', `/${transactionAccountId}`, {
    body: patch,
});
export const del = (transactionAccountId) => reqCases('DELETE', `/${transactionAccountId}`);
export const uploadFile = (transactionAccountId, upload) => reqCases('POST', `/imports/${transactionAccountId}`, { body: upload });
export const getImportById = (transactionImportId) => reqCases('GET', `/imports/${transactionImportId}`);
//# sourceMappingURL=transaction-accounts.js.map